export function _getSymbol(symbol: string) {
  if (symbol === "USD₮0" || symbol === "USDT0") symbol = "USDT";
  if (symbol === "RWA" || symbol.toLowerCase() === "xRWA".toLowerCase()) symbol = "XRWA";

  return symbol.toUpperCase();
}

async function hmacSign(data: string, key: CryptoKey) {
  const encoded = new TextEncoder().encode(data);
  const sigBytes = await window.crypto.subtle.sign("HMAC", key, encoded);
  return Array.from(new Uint8Array(sigBytes))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
}

async function sha256Hex(input: string) {
  const data = new TextEncoder().encode(input);
  const hash = await window.crypto.subtle.digest("SHA-256", data);
  return Array.from(new Uint8Array(hash))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
}

async function importHmacKey(secret: string) {
  const keyData = new TextEncoder().encode(secret);
  return window.crypto.subtle.importKey("raw", keyData, { name: "HMAC", hash: "SHA-256" }, false, ["sign"]);
}

export async function getHeaders(cryptoKey: string, method: string, path: string, bodyStr?: string) {
  const key = await importHmacKey(cryptoKey);

  const timestamp = Date.now().toString();
  // const nonce = generateNonce();
  const bodyHash = await sha256Hex(bodyStr ?? "");

  console.log(`path: ${path}`);

  // Canonical string — must exactly match server guard
  const canonical = [
    method.toUpperCase(),
    path,
    timestamp,
    // nonce,
    bodyHash,
  ].join("\n");

  const signature = await hmacSign(canonical, key);

  return {
    "x-timestamp": timestamp,
    "x-signature": signature,
    "x-client-name": "default-app",
  };
}
